function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import S from '../../../_snowpack/pkg/react-switch.js';
import styled from '../../../_snowpack/pkg/styled-components.js'; // @ts-ignore // TODO: remove when we have types

import { colors } from '../colors.js';
const ValueLabel = styled.div.withConfig({
  displayName: "shape-switch__ValueLabel",
  componentId: "sc-1pkb71c-0"
})(["height:100%;display:flex;align-items:center;font-weight:600;font-size:14px;font-family:Roboto,sans-serif;"]);
const Yes = styled(ValueLabel).withConfig({
  displayName: "shape-switch__Yes",
  componentId: "sc-1pkb71c-1"
})(["color:", ";margin-left:15px;"], colors.glacier);
const No = styled(ValueLabel).withConfig({
  displayName: "shape-switch__No",
  componentId: "sc-1pkb71c-2"
})(["justify-content:flex-end;margin-right:15px;color:", ";"], colors.label); // @ts-ignore

const Switch = styled(S.default || S).withConfig({
  displayName: "shape-switch__Switch",
  componentId: "sc-1pkb71c-3"
})(["height:min-content;"]);

function ShapeSwitch(props) {
  const {
    id,
    height = 60,
    width = 160,
    handleDiameter = 20,
    onLabel = 'Yes',
    offLabel = 'No',
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Switch, _extends({
    id: id,
    onColor: '#fff',
    offHandleColor: colors.label,
    onHandleColor: colors.glacier,
    offColor: '#fff',
    handleDiameter: handleDiameter,
    height: height,
    width: width,
    checkedIcon: /*#__PURE__*/React.createElement(Yes, null, onLabel),
    uncheckedIcon: /*#__PURE__*/React.createElement(No, null, offLabel)
  }, rest));
}

export default ShapeSwitch;